import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { FilterOption } from '@/components/Filter/types';
import WorkspaceFilter from '@/components/FilterManager/WorkspaceFilter';

type AddWorkspaceProps = {
  selectedValues: FilterOption[];
  onChange: (val: FilterOption[]) => void;
  EmptyState?: JSX.Element;
  disabled?: boolean;
  children?: React.ReactNode;
};

function AddWorkspace(props: AddWorkspaceProps) {
  const { t } = useTranslation('Workspace');
  const {
    selectedValues,
    onChange,
    EmptyState,
    disabled,
    children = <AddBlock disabled={disabled} length="short" title={t('Workspace:AddWorkspaces')} />,
  } = props;

  return (
    <WorkspaceFilter
      EmptyState={EmptyState}
      disabled={disabled}
      selectedValues={selectedValues}
      onChange={onChange}>
      {children}
    </WorkspaceFilter>
  );
}

export default AddWorkspace;
